// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xScreen } from "@conklin/XDL/Utilities";
import { dealerInformationStyles } from "@insite/content-library/Widgets/DealerDetails/DealerInformation";
import Phone from "@insite/mobius/Icons/Phone";
import { css } from "styled-components";

dealerInformationStyles.nameText = {
    color: "text.main",
    variant: "h5",
    ellipsis: true,
    css: css`
        margin: 0;
    `,
};

dealerInformationStyles.googleMapsDirectionLinkGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        padding-left: 40px;
    `,
};

dealerInformationStyles.addressInfoIcon = {
    color: "common.ui9",
    src: "MapPin",
    size: 20,
};

dealerInformationStyles.visitWebsiteLinkGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        ${xScreen("lte", "md")} {
            padding-left: 40px;
            padding-bottom: 10px;
        }
    `,
};

dealerInformationStyles.googleMapsDirectionLink = dealerInformationStyles.visitWebsiteLink = {
    typographyProps: {
        variant: "h5",
        size: 16,
        css: css`
            margin: 0;
        `,
    },
};

dealerInformationStyles.phoneLink = {
    typographyProps: {
        variant: "h5",
        size: 16,
        css: css`
            margin: 0;
            padding-left: 5px;
        `,
    },
    icon: {
        iconProps: {
            src: Phone,
            size: 20,
        },
        position: "left",
    },
};

dealerInformationStyles.addressInfoCondensed = {
    wrapper: {
        css: css`
            padding-left: 14px;
            font-style: normal;
            line-height: 19px;
        `,
    },
};
